import { DateTime } from "luxon";

export function getDefaultTermStartDate(referenceDate = new Date()): string {
  const year = referenceDate.getFullYear() + 1;
  return `${year}-04-01`;
}

export function getDefaultTermEndDate(referenceDate = new Date()): string {
  const year = referenceDate.getFullYear() + 3;
  return `${year}-03-31`;
}

export function getContinuationTermStartDate(
  active: { startDate: string; endDate: string | null },
  preferredStart: string
): string {
  if (active.endDate) {
    return DateTime.fromISO(active.endDate, { zone: "utc" }).plus({ days: 1 }).toISODate() ?? preferredStart;
  }

  if (preferredStart > active.startDate) return preferredStart;

  return DateTime.fromISO(active.startDate, { zone: "utc" }).plus({ days: 1 }).toISODate() ?? preferredStart;
}
